import React from 'react';
import { useParams } from 'react-router-dom';
import { Loading } from '../../common/components/Loading';
import { Spacer, TitleSmall } from '../../common/components/v2';
import Graph from '../detail/rulesGraph/Graph';
import styles from './styles.module.scss';
import useRawTraceMap from './useRawTraceMap';

const PPWBPolicyEvidenceGraph = () => {
  const { policyId, decisionId } = useParams<{
    policyId: string;
    decisionId: string;
  }>();

  const { traceMap, isLoading } = useRawTraceMap(
    policyId as string,
    Number(decisionId),
  );

  if (!traceMap || isLoading) {
    return <Loading fullscreen />;
  }

  return (
    <div className={styles.GraphLayout}>
      <TitleSmall>{`Rule Tracemap Graph (Policy: ${policyId})`}</TitleSmall>
      <Spacer height={8} />
      <Graph traceMap={traceMap} />
    </div>
  );
};

export default PPWBPolicyEvidenceGraph;
